package tables.placementCat

import emotion.react.css
import entities.Ad
import entities.PlacementCat
import kotlinx.browser.window
import models.CategoryModel
import org.w3c.fetch.RequestInit
import placementCatToJsonString
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.select
import react.useState
import token
import urlAddress
import web.cssom.*
import web.http.Headers

external interface CreatePlacementCatProps : Props {
    var isOpen: Boolean
    var onClose: () -> Unit
    var onUpdate: () -> Unit
    var listCat: List<CategoryModel>
    var listAd: List<Ad>
}

val CreatePlacementCatModal = FC<CreatePlacementCatProps> { props ->
    if (props.isOpen) {
        var catId by useState(0)
        var adId by useState(0)
        var status by useState("")

        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                p {
                    +"Категория:"
                }
                div {
                    select {
                        option {
                            value = 0
                            +""
                        }
                        props.listCat.forEach {
                            option {
                                value = it.id
                                +it.name
                            }
                        }
                        onChange = {
                            catId = it.target.value.toInt()
                        }
                    }
                }
                p {
                    +"Реклама:"
                }
                div {
                    select {
                        option {
                            value = 0
                            +""
                        }
                        props.listAd.forEach {
                            option {
                                value = it.id
                                +it.name
                            }
                        }
                        onChange = {
                            adId = it.target.value.toInt()
                        }
                    }
                }
                div {
                    css {
                        paddingTop = 20.px
                        display = Display.flex
                        justifyContent = JustifyContent.spaceAround
                    }
                    button {
                        disabled = (catId == 0) || (adId == 0)
                        +"Сохранить"
                        val placementCat = PlacementCat(0, catId, adId)
                        onClick = {
                            window.fetch(
                                urlAddress + "api/placement", RequestInit(
                                    method = "POST",
                                    headers = Headers().apply {
                                        append("Authorization", "Bearer $token")
                                        append("Content-Type", "application/json")
                                    },
                                    body = placementCatToJsonString(placementCat)
                                )
                            )
                                .then { response ->
                                    if (response.ok) {
                                        props.onClose()
                                        props.onUpdate()
                                    } else {
                                        response.text().then { errorMessage ->
                                            status = errorMessage
                                        }
                                    }
                                }
                        }
                    }
                    button {
                        +"Отмена"
                        onClick = {
                            props.onClose()
                        }
                    }
                }
                p {
                    +status
                }
            }
        }
    }
}

